import { ShopPickerController } from './shopPicker.controller';

const angular = require('angular');

export default angular.module('directives.shopPicker', [])
    .component('shopPicker', {
        template: require('./index.pug'),
        controller: ShopPickerController,
        controllerAs: 'picker',
        bindings: {
            onSelected: '&',
            onReset: '&',
            autosend: '='
        },
        bindToController: true,
    })
    .name;



// WEBPACK FOOTER //
// ./client/components/shopPicker/index.ts